<template>
    <div class="wallet-topup-page">
      <div class="card-wrapper">
        <div class="topup-card">
          
          <!-- Icon / Header -->
          <div class="card-header">
            <i class="bi bi-lock-fill lock-icon"></i>
            <h2>VIP Access Restricted</h2>
          </div>
  
          <!-- Message -->
            <div class="card-body">
              <p class="message">
                Your wallet balance is currently insufficient to grant you access to the VIP Lounge.
              </p>
  
              <p class="highlight">
                A minimum balance of <strong>3,000 tokens</strong> is required to unlock and access the VIP page.
              </p>
  
              <p>
                Maintaining this balance helps ensure that clients who interact within the VIP environment are financially prepared and genuinely interested in premium engagements.
              </p>
  
              <p>
                <strong>Important:</strong> This token requirement is <u>not a direct payment to VIPs</u>. It serves solely as a credibility and commitment indicator, showing VIPs that you are serious about participating in exclusive interactions.
              </p>
  
              <p>
                We recommend funding your wallet with sufficient tokens to enjoy uninterrupted access to VIP features and experiences.
              </p>
            </div>
  
          <!-- Actions -->
          <div class="card-actions">
            <button class="btn btn-primary" @click="buyToken">
              <i class="bi bi-wallet2"></i>
              Buy Token
            </button>
  
            <button class="btn btn-outline" @click="goBack">
              Go Back
            </button>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "WalletTopup",

    data() {
      return {
          userid: '',
          username: '',
      };
    },
    
    mounted() {
          this.userid = localStorage.getItem("userid");
          this.username = localStorage.getItem("name");
    },

    methods: {
      buyToken() {
        // Redirect to client profile (adjust route if dynamic)
        this.$router.push(`/guest-profile/${this.userid}/${this.username}`);
      },
  
      goBack() {
        this.$router.back();
      }
    }
  };
  </script>
  
  <style scoped>
  .wallet-topup-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #0f172a, #020617);
    padding: 20px;
  }
  
  .card-wrapper {
    width: 100%;
    max-width: 520px;
  }
  
  .topup-card {
    background: #ffffff;
    border-radius: 20px;
    padding: 30px 28px;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
    text-align: center;
    animation: fadeIn 0.35s ease;
  }
  
  .card-header h2 {
    margin-top: 10px;
    font-size: 22px;
    color: #111827;
  }
  
  .lock-icon {
    font-size: 42px;
    color: #ef4444;
  }
  
  .card-body {
    margin-top: 18px;
    text-align: left;
    color: #374151;
    font-size: 15px;
    line-height: 1.6;
    max-height: 260px;
    overflow-y: auto;
    padding-right: 6px;
    margin-top: 18px;
    text-align: left;
    color: #374151;
    font-size: 15px;
    line-height: 1.6;
  }
  
  .card-body p {
    margin-bottom: 14px;
  }
  
  .message {
    font-size: 16px;
  }
  
  .card-actions {
    margin-top: 24px;
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .btn {
    padding: 11px 18px;
    border-radius: 10px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: 0.2s ease;
  }
  
  .btn-primary {
    background: #ef4444;
    color: #fff;
  }
  
  .btn-primary:hover {
    background: #390d0d;
  }
  
  .btn-outline {
    background: transparent;
    border: 1.5px solid #d1d5db;
    color: #111827;
  }
  
  .btn-outline:hover {
    background: #f3f4f6;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  </style>
  